import { render, staticRenderFns } from "./preview-recipients.vue?vue&type=template&id=688ae6d1&scoped=true&"
import script from "./preview-recipients.vue?vue&type=script&lang=js&"
export * from "./preview-recipients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688ae6d1",
  null
  
)

export default component.exports